import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetAllLogisticsLoadsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.LoadDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.LoadDocumentSortInput> | Types.LoadDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAllLogisticsLoadsQuery = { __typename?: 'Query', logisticsLoads?: { __typename?: 'LogisticsLoadsConnection', totalCount: number, nodes?: Array<{ __typename?: 'LoadDocument', id: string, tenantId: string, loadId: string, loadNumber: number, routeId?: string | null, vehicleId?: string | null, carrierId?: string | null, driverId?: string | null, shipDate: string, status: Types.LoadStatus, containerConfigId?: string | null, containerName: string, dockId?: string | null, miles?: number | null, milesSource: Types.MilesSource, milesItinerary: Array<string>, transitKind: Types.TransitKind, updatedAt: Types.TDateISO, updatedBy: string, plannedArrivals: Array<{ __typename?: 'PlannedArrivalDocument', routeStopId: string, time: string }>, pickupWindow?: { __typename?: 'PickupWindowDocument', date: string, from: string, to: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type LogisticsLoadDocumentFieldsFragment = { __typename?: 'LoadDocument', id: string, tenantId: string, loadId: string, loadNumber: number, routeId?: string | null, vehicleId?: string | null, carrierId?: string | null, driverId?: string | null, shipDate: string, status: Types.LoadStatus, containerConfigId?: string | null, containerName: string, dockId?: string | null, miles?: number | null, milesSource: Types.MilesSource, milesItinerary: Array<string>, transitKind: Types.TransitKind, updatedAt: Types.TDateISO, updatedBy: string, plannedArrivals: Array<{ __typename?: 'PlannedArrivalDocument', routeStopId: string, time: string }>, pickupWindow?: { __typename?: 'PickupWindowDocument', date: string, from: string, to: string } | null };

export type PlannedArrivalNoticeWarningFieldsFragment = { __typename?: 'PlannedArrivalNoticeWarning', code: Types.PlannedArrivalNoticeWarningCode, orderNumbers: Array<string>, orderDeliveryDate: string, plannedDeliveryDate: string };

export type LoadEmailFieldsFragment = { __typename?: 'LoadEmailDocument', id: string, reservationId: string, status: Types.LoadEmailStatus, attempt: number, version: number, corrected: boolean, plannedTime?: string | null, recipients: Array<string>, failureReason?: string | null, updatedAt: Types.TDateISO };

export type GetLoadStopNoticeStatusQueryVariables = Types.Exact<{
  loadId: Types.Scalars['String']['input'];
}>;


export type GetLoadStopNoticeStatusQuery = { __typename?: 'Query', loadStopNoticeStatus: Array<{ __typename?: 'LoadStopNoticeStatus', routeStopId: string, storeName: string, stopNumber: number, plannedTime?: string | null, plannedDeliveryDate: string, readiness: Types.PlannedArrivalNoticeReadiness, missingField?: string | null, blockingOrderNumber?: string | null, recipients: Array<string>, stale: boolean, changedFields: Array<string>, warnings: Array<{ __typename?: 'PlannedArrivalNoticeWarning', code: Types.PlannedArrivalNoticeWarningCode, orderNumbers: Array<string>, orderDeliveryDate: string, plannedDeliveryDate: string }>, lastRequest?: { __typename?: 'LoadEmailDocument', id: string, reservationId: string, status: Types.LoadEmailStatus, attempt: number, version: number, corrected: boolean, plannedTime?: string | null, recipients: Array<string>, failureReason?: string | null, updatedAt: Types.TDateISO } | null, lastSent?: { __typename?: 'EmailSendDocument', id: string, sentAt: Types.TDateISO, plannedTime?: string | null, stopNumber?: number | null, operatorAsserted?: boolean | null, recipients: Array<{ __typename?: 'EmailSendRecipientDocument', email: string }> } | null }> };

export type GetLoadMilesOrdersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrdersDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrdersDocumentSortInput> | Types.OrdersDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetLoadMilesOrdersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', orderId: string, orderNumber: string, shipFromSiteLocationId: string, locations: { __typename?: 'OrderLocationDocumentData', id: string }, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type LoadMilesOrderFieldsFragment = { __typename?: 'OrdersDocument', orderId: string, orderNumber: string, shipFromSiteLocationId: string, locations: { __typename?: 'OrderLocationDocumentData', id: string }, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null };

export type FreightQuoteSendFieldsFragment = { __typename?: 'FreightQuoteSend', reservationId: string, state: Types.LoadEmailStatus, recipientEmail: string, sentAt?: Types.TDateISO | null, failureReason?: string | null };

export type GetFreightQuoteSendStatusQueryVariables = Types.Exact<{
  loadId: Types.Scalars['ID']['input'];
}>;


export type GetFreightQuoteSendStatusQuery = { __typename?: 'Query', freightQuoteSendStatus?: { __typename?: 'FreightQuoteSend', reservationId: string, state: Types.LoadEmailStatus, recipientEmail: string, sentAt?: Types.TDateISO | null, failureReason?: string | null } | null };

export const LogisticsLoadDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsLoadDocumentFields on LoadDocument {
  id
  tenantId
  loadId
  loadNumber
  routeId
  vehicleId
  carrierId
  driverId
  shipDate
  status
  containerConfigId
  containerName
  dockId
  miles
  milesSource
  milesItinerary
  transitKind
  updatedAt
  updatedBy
  plannedArrivals {
    routeStopId
    time
  }
  pickupWindow {
    date
    from
    to
  }
}
    `, {"fragmentName":"LogisticsLoadDocumentFields"});
export const PlannedArrivalNoticeWarningFieldsFragmentDoc = new TypedDocumentString(`
    fragment PlannedArrivalNoticeWarningFields on PlannedArrivalNoticeWarning {
  code
  orderNumbers
  orderDeliveryDate
  plannedDeliveryDate
}
    `, {"fragmentName":"PlannedArrivalNoticeWarningFields"});
export const LoadEmailFieldsFragmentDoc = new TypedDocumentString(`
    fragment LoadEmailFields on LoadEmailDocument {
  id
  reservationId
  status
  attempt
  version
  corrected
  plannedTime
  recipients
  failureReason
  updatedAt
}
    `, {"fragmentName":"LoadEmailFields"});
export const LoadMilesOrderFieldsFragmentDoc = new TypedDocumentString(`
    fragment LoadMilesOrderFields on OrdersDocument {
  orderId
  orderNumber
  shipFromSiteLocationId
  locations {
    id
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
}
    fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`, {"fragmentName":"LoadMilesOrderFields"});
export const FreightQuoteSendFieldsFragmentDoc = new TypedDocumentString(`
    fragment FreightQuoteSendFields on FreightQuoteSend {
  reservationId
  state
  recipientEmail
  sentAt
  failureReason
}
    `, {"fragmentName":"FreightQuoteSendFields"});
export const GetAllLogisticsLoadsDocument = new TypedDocumentString(`
    query GetAllLogisticsLoads($where: LoadDocumentFilterInput, $order: [LoadDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  logisticsLoads(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...LogisticsLoadDocumentFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment LogisticsLoadDocumentFields on LoadDocument {
  id
  tenantId
  loadId
  loadNumber
  routeId
  vehicleId
  carrierId
  driverId
  shipDate
  status
  containerConfigId
  containerName
  dockId
  miles
  milesSource
  milesItinerary
  transitKind
  updatedAt
  updatedBy
  plannedArrivals {
    routeStopId
    time
  }
  pickupWindow {
    date
    from
    to
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetLoadStopNoticeStatusDocument = new TypedDocumentString(`
    query GetLoadStopNoticeStatus($loadId: String!) {
  loadStopNoticeStatus(loadId: $loadId) {
    routeStopId
    storeName
    stopNumber
    plannedTime
    plannedDeliveryDate
    readiness
    missingField
    blockingOrderNumber
    recipients
    warnings {
      ...PlannedArrivalNoticeWarningFields
    }
    stale
    changedFields
    lastRequest {
      ...LoadEmailFields
    }
    lastSent {
      id
      sentAt
      recipients {
        email
      }
      plannedTime
      stopNumber
      operatorAsserted
    }
  }
}
    fragment PlannedArrivalNoticeWarningFields on PlannedArrivalNoticeWarning {
  code
  orderNumbers
  orderDeliveryDate
  plannedDeliveryDate
}
fragment LoadEmailFields on LoadEmailDocument {
  id
  reservationId
  status
  attempt
  version
  corrected
  plannedTime
  recipients
  failureReason
  updatedAt
}`);
export const GetLoadMilesOrdersDocument = new TypedDocumentString(`
    query GetLoadMilesOrders($where: OrdersDocumentFilterInput, $order: [OrdersDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  orders(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...LoadMilesOrderFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment LoadMilesOrderFields on OrdersDocument {
  orderId
  orderNumber
  shipFromSiteLocationId
  locations {
    id
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const GetFreightQuoteSendStatusDocument = new TypedDocumentString(`
    query GetFreightQuoteSendStatus($loadId: ID!) {
  freightQuoteSendStatus(loadId: $loadId) {
    ...FreightQuoteSendFields
  }
}
    fragment FreightQuoteSendFields on FreightQuoteSend {
  reservationId
  state
  recipientEmail
  sentAt
  failureReason
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetAllLogisticsLoads: build.query<GetAllLogisticsLoadsQuery, GetAllLogisticsLoadsQueryVariables | void>({
      query: (variables) => ({ document: GetAllLogisticsLoadsDocument, variables })
    }),
    GetLoadStopNoticeStatus: build.query<GetLoadStopNoticeStatusQuery, GetLoadStopNoticeStatusQueryVariables>({
      query: (variables) => ({ document: GetLoadStopNoticeStatusDocument, variables })
    }),
    GetLoadMilesOrders: build.query<GetLoadMilesOrdersQuery, GetLoadMilesOrdersQueryVariables | void>({
      query: (variables) => ({ document: GetLoadMilesOrdersDocument, variables })
    }),
    GetFreightQuoteSendStatus: build.query<GetFreightQuoteSendStatusQuery, GetFreightQuoteSendStatusQueryVariables>({
      query: (variables) => ({ document: GetFreightQuoteSendStatusDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetAllLogisticsLoadsQuery, useLazyGetAllLogisticsLoadsQuery, useGetLoadStopNoticeStatusQuery, useLazyGetLoadStopNoticeStatusQuery, useGetLoadMilesOrdersQuery, useLazyGetLoadMilesOrdersQuery, useGetFreightQuoteSendStatusQuery, useLazyGetFreightQuoteSendStatusQuery } = injectedRtkApi;
